import * as vp from 'vopay';
import { FunctionComponent, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useClientData } from '../../../providers/ClientData.provider';
import useFetchAutoBalanceTransfer from '../../../hooks/useApi/useFetchAutoBalanceTransfer';
import { useTranslation } from 'react-i18next';

const { Box, Description, Button, Title } = vp;

type FC = FunctionComponent;

const BalanceTransferOverviewContainer: FC = () => {
  const history = useHistory();
  const { response } = useClientData();
  const [autoBalanceTransferResponse, fetchAutoBalanceTransfer] = useFetchAutoBalanceTransfer({});

  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AutoBalanceTransfer' });

  useEffect(() => {
    fetchAutoBalanceTransfer({
      PortalUser: response.LoginUserName,
    });
  }, []);

  useEffect(() => {
    if (autoBalanceTransferResponse.Status === '') {
      history.push('/auto-balance-transfer');
    } else if (autoBalanceTransferResponse.Status === 'in progress') {
      history.push('/auto-balance-transfer/overview');
    }
  }, [autoBalanceTransferResponse]);

  return (autoBalanceTransferResponse.Success === false &&
    autoBalanceTransferResponse.ErrorMessage.includes('auto balance transfer set up yet')) ||
    (autoBalanceTransferResponse.Success === true && autoBalanceTransferResponse.Status === 'cancelled') ? (
    <Box flx="col">
      <Box mb="md" jc="sb">
        <Title title={t('title')} />
      </Box>
      <Box width="100%" minheight="300px" flx="col" gap="lg" jc="center" ai="center">
        <Box maxwidth="80%">
          <Description align="center">{t('description')}</Description>
        </Box>
        <Button
          id="setup-automated-transfer"
          label={t('createAutoBalanceTransferButton')}
          width="230px"
          onClick={() => {
            history.push({
              pathname: '/create-auto-balance-transfer',
              state: { title: 'Create' },
            });
          }}
        />
      </Box>
    </Box>
  ) : (
    <Box>
      <Title title={t('title')} />
    </Box>
  );
};

export default BalanceTransferOverviewContainer;
